import React, { useEffect, useState, useReducer } from "react";
import FullScreenButton from "../dashboard/FullScreenButton";
import RefreshButton from "../reporting_utils/RefreshButton";
import DomainSidebar from "./DomainSidebar";
import { BadgeList, Badge } from "../reporting_utils/Badge";

const pageLoadingFrame = window.pageLoadingFrame;

export default function Outbound() {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [currentDomain, setCurrentDomain] = useState();
  const [iframeURL, setIframeURL] = useState("");
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [error, setError] = useState(false);

  // This is just used to change the iframe element's key prop
  // when the refresh button is clicked, forcing it to rerender.
  const [iframeKey, setIframeKey] = useReducer((c) => c + 1, 0);

  useEffect(() => {
    setError(false);

    if (!currentDomain) {
      return;
    }
    setIframeURL("");
    pageLoadingFrame("show");
    fetch(`/reports/cs_ids?id=${currentDomain.value}`)
      .then((res) => res.json())
      .then((data) => {
        const { cs_location_id, cs_account_id } = data;
        if (!cs_account_id || !cs_location_id) {
          setError(true);
        } else {
          const rand = Math.floor(Math.random() * 1000000 + 1);
          setIframeURL(
            `https://api.callsource.com/crmreports/outbound_processing?customerId=${cs_location_id}&accountId=${cs_account_id}&r=${rand}`
          );
        }
        pageLoadingFrame("hide");
      });
  }, [currentDomain]);

  return (
    <div className={`report-details-container ${isFullScreen ? "panel-fullscreen-wrap" : ""}`}>
      <div className="report-details-header">
        <div className="report-details-title">
          <h1>Outbound Employee Calls</h1>
        </div>
        <div className="panel-header">
          <FullScreenButton setIsFullScreen={setIsFullScreen} isFullScreen={isFullScreen} />
          {currentDomain ? <RefreshButton dataCallbacks={setIframeKey} /> : null}
        </div>
      </div>
      <DomainSidebar
        open={sidebarIsOpen}
        setOpen={setSidebarIsOpen}
        setCurrentDomain={setCurrentDomain}
      />
      {currentDomain ? (
        <>
          <div className="applied-filters-container">
            <div style={{ marginBottom: "20px" }}>
              <button className="btn btn-primary" onClick={() => setSidebarIsOpen(!sidebarIsOpen)}>
                <span className="fa fa-plus" /> Select Location
              </button>
            </div>
            <BadgeList title="Selected location">
              <Badge label={currentDomain.label} />
            </BadgeList>
          </div>
          <div style={{ marginTop: "20px" }}>
            {error ? (
              <p className="text-center">
                Outbound report not available for this location
              </p>
            ) : iframeURL ? (
              <iframe key={iframeKey} width="100%" height="1000" frameBorder="0" src={iframeURL} />
            ) : null}
          </div>
        </>
      ) : (
        <div style={{ marginTop: "50px" }} className="text-center">
          <h4>No location selected</h4>
          <p>Get started running your report by selecting a location</p>
          <div>
            <button className="btn btn-primary" onClick={() => setSidebarIsOpen(true)}>
              <span className="fa fa-plus" /> Select Location
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
